import { IInvitationRepository } from '../ports/outbound/IInvitationRepository';
import { SendInvitationResult } from '../domain/entities/SendInvitationResult';
import { SendInvitationInput } from '../domain/entities/SendInvitationInput';

export class SendInvitationUseCase {
  constructor(private readonly invitationRepository: IInvitationRepository) {}

  async execute(input: SendInvitationInput): Promise<SendInvitationResult> {
    return this.invitationRepository.sendInvitation(input);
  }
}
